import { SET_ELCCABINETS } from '../constants/ELCCabinetConstants';

const initialState = {
  elccabinets: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ELCCABINETS: {
      return {
        ...state,
        elccabinets: action.payload,
        updated: false,
      };
    }

    default:
      return state;
  }
}
